import React, { createContext, useContext, useState, useEffect } from 'react';

const AuthContext = createContext();

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
};

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const normalizeUser = (userData) => {
    if (!userData || typeof userData !== 'object') return userData;
    if (!userData.id && userData._id) {
      return { ...userData, id: userData._id };
    }
    return userData;
  };

  useEffect(() => {
    const token = localStorage.getItem('token');
    const userData = localStorage.getItem('user');
    
    if (token && userData) {
      console.log('AuthContext - useEffect userData:', userData);
      const parsedUser = JSON.parse(userData);
      const normalizedUser = normalizeUser(parsedUser);
      setUser(normalizedUser);
      if (normalizedUser?.id && !parsedUser?.id) {
        localStorage.setItem('user', JSON.stringify(normalizedUser));
      }
    }
    setLoading(false);
  }, []);

  const login = (userData, token) => {
    console.log('AuthContext - Login userData:', userData);
    const normalizedUser = normalizeUser(userData);
    setUser(normalizedUser);
    localStorage.setItem('token', token);
    localStorage.setItem('user', JSON.stringify(normalizedUser));
  };

  const logout = () => {
    setUser(null);
    localStorage.removeItem('token');
    localStorage.removeItem('user');
  };

  const updateUser = (userData) => {
    const normalizedUser = normalizeUser(userData);
    setUser(normalizedUser);
    localStorage.setItem('user', JSON.stringify(normalizedUser));
  };

  const value = {
    user,
    login,
    logout,
    updateUser,
    loading
  };

  return (
    <AuthContext.Provider value={value}>
      {children}
    </AuthContext.Provider>
  );
};